import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';

const LoadingTaskRow = ({
  classes,
  columns = 8,
}) => (
  <TableRow
    sx={classes.row}
    style={{ borderLeft: '4px solid inherit' }}
  >
    <TableCell />
    <TableCell
      sx={{
        ...classes.cell,
        width: 150,
        minWidth: 150,
        maxWidth: 150,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          ml: '6px',
        }}
      >
        <Skeleton variant="circular" width={40} height={40} sx={{ marginRight: 1 }} />
        <Skeleton
          variant="text"
          width={50}
          height={55}
          sx={{
            color: 'action.active',
            mr: 1,
            my: 0.5,
          }}
        />
      </Box>
    </TableCell>
    {
      Array.from({ length: columns - 1 }, (_, i) => (
        <TableCell
          key={i}
          sx={classes.cell}
        >
          <Skeleton
            variant="text"
            height={55}
            sx={{
              borderRadius: 2,
              ml: '6px',
              mr: '6px',
            }}
          />
        </TableCell>
      ))
    }
  </TableRow>
);

LoadingTaskRow.propTypes = { classes: PropTypes.object };

LoadingTaskRow.defaultProps = { classes: {} };

export default LoadingTaskRow;
